"use client";

import dynamic from "next/dynamic";

const DataflowAnimation = dynamic(() => import("./DataflowAnimation"), { ssr: false });

export default function DataflowAnimationWrapper() {
  return <DataflowAnimation />;
}
